import { Box, Card, CardContent, CardHeader, CircularProgress, Table, TableCell, TableRow, Typography } from "@mui/material";
import React from "react";
import { useDownloadUsers } from "./DownloadUsersContext";


const DownloadUserList = () => {
    const { downloadUserAcc } = useDownloadUsers();
    const dispRoles = (roles) => {
        return(
        roles.map((eachrole, idx) => {
        //   if(idx === 0 && roles.length === 1)  return (
        //         eachrole 
        //     )
        //     else 
            return eachrole + '\n'
        }))
    }
    if( downloadUserAcc !=null && downloadUserAcc.length > 0){
    return (
        <Card>
            <CardHeader sx={{textAlign:'center'}} variant="h5" 
                title = 'Manage User Accounts' 
            />
            <CardContent>
                <Table size="small">
                    <TableRow className="report-header">
                        <TableCell> Id </TableCell>
                        <TableCell> Login </TableCell>
                        <TableCell> Name </TableCell>
                        <TableCell> Organization </TableCell>
                        <TableCell> Email </TableCell>
                        <TableCell> Roles </TableCell>
                        <TableCell> Agreement Sent </TableCell>
                        <TableCell> Agreement Received </TableCell>
                        <TableCell> Approved </TableCell>
                        <TableCell> Updated </TableCell>
                    </TableRow> 
                 {downloadUserAcc.map((eachdownloadUserAcc, idx) => {
                    return (
                        <TableRow className={idx % 2 === 0 ? "styledtablerow" : ""}>
                            <TableCell> {eachdownloadUserAcc.id} </TableCell>
                            <TableCell> {eachdownloadUserAcc.login} </TableCell>
                            <TableCell> {eachdownloadUserAcc.name} </TableCell>
                            <TableCell> {eachdownloadUserAcc.organization} </TableCell>
                            <TableCell> {eachdownloadUserAcc.email} </TableCell>
                            <TableCell> {dispRoles(eachdownloadUserAcc.roles)} </TableCell>
                            <TableCell> {eachdownloadUserAcc.agreementSent} </TableCell>
                            <TableCell> {eachdownloadUserAcc.aggrementReceived} </TableCell>
                            <TableCell> {eachdownloadUserAcc.approved} </TableCell>
                            <TableCell> {eachdownloadUserAcc.updated} </TableCell>
                        </TableRow>
                    )
                 })}   
                </Table>
            </CardContent>
        </Card>
    )
} 
else {
    return(
        <Box sx={{ width: "100%", textAlign: "center", mt: 5 }}>
            <CircularProgress />
        </Box>
    )

}
}

export default DownloadUserList;